import * as React from 'react';
import { NumberFormatBaseProps, NumericFormat } from 'react-number-format';

type Props = {
  value: number;
  renderText?: (formattedValue: string, otherProps: Partial<NumberFormatBaseProps>) => React.ReactNode;
  showSuffix?: boolean;
  showPrefix?: boolean;
};

const ISKFormat = ({ value, renderText, showSuffix = true, showPrefix = false }: Props) => {
  return (
    <NumericFormat
      value={value}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={0}
      displayType="text"
      prefix={showPrefix ? '+ ' : undefined}
      suffix={showSuffix ? ' kr.' : undefined}
      renderText={renderText}
    />
  );
};

export default ISKFormat;
